import React from "react";
import Logo from "../../assets/E.ON_Next_logo.svg";

/** Display an error */
const FailedPage = (): JSX.Element => (
  <main className="main">
    <section className="logo-container">
      <img className="main-logo" alt="E.ON Next logo" src={Logo} />
    </section>
    <section className="text">
      <h5>Opps! looks like something went wrong.</h5>
      <h1>Sorry we are working on it.</h1>
    </section>
  </main>
);

export default FailedPage;
